<template>
    <div class="site-main-container">

        <div v-if="this.impersonated && this.impersonatedUrl" class="impersonating-banner">
            <app-icon :name="'user'" width="22" height="22" class="mb-1 mr-1" /> {{ $t("impersonating_as_employee") }} {{ this.impersonated.name }} {{ this.impersonated.surname }}
        </div>
        
        <div class="checklist-container border-0">
            <div class="site-logo">
                <img :src="this.settings.company_logo" />
            </div>
            <div v-if="this.user.addressing_by_name" class="d-flex mb-3">
                <div>
                    <h2>
                        {{ this.settings.company_greeting ? this.settings.company_greeting : "Ahoj" }} {{ this.impersonated.addressing_by_name ? this.impersonated.addressing_by_name : this.user.addressing_by_name }},<br />
                        co by {{ this.settings.company_addressing == "tebe" ? "tě" : "Vás" }} zajímalo?
                    </h2>
                </div>
            </div>
            <h3>Úvodem</h3>
            <ul class="site-menu-subcategories">
                <li :class="selectedId == 2 ? 'active' : ''"><a :href="'2' + this.impersonatedUrl">První den 🚀</a></li>
                <li :class="selectedId == 5 ? 'active' : ''"><a :href="'5' + this.impersonatedUrl">Přivítání od generálního</a></li>
            </ul>

            <h3>O nás</h3>
            <ul class="site-menu-subcategories">
                <li :class="selectedId == 4 ? 'active' : ''"><a :href="'4' + this.impersonatedUrl">Co nás pohání 🔥</a></li>
                <li :class="selectedId == 6 ? 'active' : ''"><a :href="'6' + this.impersonatedUrl">Benefity a dovolené</a></li>
                <li :class="selectedId == 7 ? 'active' : ''"><a :href="'7' + this.impersonatedUrl">Naše mise a vize 💥</a></li>
            </ul>
        </div>

        <div class="border-0 mb-primary" :class="this.impersonateAs ? 'col-12 col-md-9 p-0 card-left' : 'w-100'">
            <div class="site-bg-image" :style="this.settings.company_banner ? 'background-image: linear-gradient(rgba(255, 255, 255, 0.6) 0px, rgba(255, 255, 255, 1.0) 600px), url('+this.settings.company_banner+')' : ''"></div>

            <app-overlay-loader v-if="preloader" />

            <div class="site-menu">
                <a :href="'/employee/dashboard' + this.impersonatedUrl" class="btn btn-transparent">
                    {{ $t("tasks") }}
                </a>
                <a :href="'/employee/wiki/2' + this.impersonatedUrl" class="btn btn-light">
                    {{ $t("employee_wiki") }}
                </a>
            </div>
            <form ref="form" :data-url="selectedUrl ? selectedUrl : `onboardingsites`" class="site-content mb-0" :class="{ 'loading-opacity': preloader }">
                <div v-if="this.impersonateAs && this.newOnboardio" class="site-container onboarding-site-container">
                    <div class="site-preheader row p-5">
                        <div class="col-12 col-md-8">
                            <h3 v-if="this.impersonated.timeline_state == 8" class="mb-0">
                                <strong>{{ $t("today_we_are_looking_forward_to_see_you_in_the_office") }}</strong>
                            </h3>
                            <h3 v-else class="mb-0">
                                <strong>{{ $t("we_are_looking_forward_to_see_you_in_the_office") }}</strong>
                            </h3>
                        </div>
                        <div v-if="this.impersonated.event_date" class="col-12 col-md-4 text-right">
                            <app-icon :name="'calendar'" width="30" height="30" class="mb-1 mr-2" /><strong>{{ formatDate(this.impersonated.event_date) }}</strong> <app-icon :name="'clock'" width="30" height="30" class="mb-1 mr-2 ml-4" /><strong>{{ formatTime(this.impersonated.event_date) }}</strong>
                        </div>
                        <div v-else class="col-12 col-md-4">
                            <app-icon :name="'calendar'" width="30" height="30" class="mb-1 mr-2" /><strong>{{ $t("onboarding_start_date_not_entered_employee") }}</strong>
                        </div>
                    </div>
                </div>
                <div v-if="selectedId" class="site-container onboarding-site-container">
                    <!-- Start of header -->
                    <section class="body-container">
                        <div class="d-flex align-items-center justify-content-center flex-column full-height-column main-headline">
                            <div class="p-2">
                                <div v-if="!this.ableToEdit" v-html="this.header.text"></div>
                                <app-input v-else-if="finishedGetData" class="col-sm-12 medium-editor" type="text-editor" v-model="header.text" :placeholder="$t('text_type_input')" />
                            </div>
                        </div>
                        <div v-if="this.ableToEdit" class="col-sm-12 offset-md-2 col-md-8 images">
                            <div v-for="image in this.inputs.images.body1" class="col-sm-12">
                                <button type="submit" class="btn btn-secondary btn-sm btn-circle btn-top-right" @click.prevent="removeImageFromChosenPlace(image, 'body1')">
                                    <app-icon :name="'trash'" width="25" height="25" />
                                </button>

                                <img :src="image" />
                            </div>
                            <div class="col-sm-12 text-center">
                                <button type="submit" class="btn btn-primary btn-sm" @click.prevent="addImageTo('body1')"><app-icon :name="'plus'" width="25" height="25" /> {{ $t("add_image") }}</button>
                            </div>
                        </div>
                        <div v-else class="col-sm-12 offset-md-2 col-md-8 images">
                            <div v-for="image in this.inputs.images.body1" class="col-sm-12">
                                <img :src="image" />
                            </div>
                        </div>
                    </section>

                    <!-- Start of body -->
                    <section class="body-container container-md row">
                        <div class="col-sm-12  col-md-12 images">
                            <!-- <div v-if="this.impersonateAs" -->
                            <div v-if="!this.ableToEdit" v-html="this.body.text1"></div>
                            <!--  && this.impersonateAs == 0 -->
                            <app-input v-else-if="finishedGetData" class="col-sm-12" type="text-editor" v-model="body.text1" :placeholder="$t('text_type_input')" />

                            <div v-if="this.ableToEdit" class="col-sm-12 col-md-4">
                                <div v-for="image in this.inputs.images.body2" class="col-sm-12">
                                    <button type="submit" class="btn btn-secondary btn-sm btn-circle btn-top-right" @click.prevent="removeImageFromChosenPlace(image, 'body2')">
                                        <app-icon :name="'trash'" width="25" height="25" />
                                    </button>

                                    <img :src="image" />
                                </div>
                            </div>
                            <div v-else class="col-sm-12 col-md-4">
                                <div v-for="image in this.inputs.images.body2" class="col-sm-12">
                                    <img :src="image" />
                                </div>
                            </div>
                            <div v-if="this.ableToEdit" class="col-sm-12 text-center">
                                <button type="submit" class="btn btn-primary btn-sm" @click.prevent="addImageTo('body2')"><app-icon :name="'plus'" width="25" height="25" /> {{ $t("add_image") }}</button>
                            </div>

                            <div v-if="!this.ableToEdit" v-html="this.body.text2"></div>
                            <app-input v-else-if="finishedGetData" class="col-sm-12 mb-2" type="text-editor" v-model="body.text2" :placeholder="$t('text_type_input')" />

                            <div class="clearfix"></div>
                            <hr style="border-width: 2px" />

                            <div v-if="!this.ableToEdit" v-html="this.body.text3"></div>
                            <app-input v-else-if="finishedGetData" class="col-sm-12" type="text-editor" v-model="body.text3" :placeholder="$t('text_type_input')" />

                            <div v-if="this.ableToEdit" class="col-sm-12 col-md-12">
                                <div v-for="image in this.inputs.images.body3" class="col-sm-12">
                                    <button type="submit" class="btn btn-secondary btn-sm btn-circle btn-top-right" @click.prevent="removeImageFromChosenPlace(image, 'body3')">
                                        <app-icon :name="'trash'" width="25" height="25" />
                                    </button>

                                    <img :src="image" />
                                </div>
                            </div>
                            <div v-else class="col-sm-12 col-md-12">
                                <div v-for="image in this.inputs.images.body3" class="col-sm-12">
                                    <img :src="image" />
                                </div>
                            </div>
                            <div v-if="this.ableToEdit" class="col-sm-12 text-center">
                                <button type="submit" class="btn btn-primary btn-sm" @click.prevent="addImageTo('body3')"><app-icon :name="'plus'" width="25" height="25" /> {{ $t("add_image") }}</button>
                            </div>
                        </div>
                        <div class="col-sm-12 col-md-12 images">
                            <div v-if="!this.ableToEdit" v-html="this.body.text4"></div>
                            <app-input v-else-if="finishedGetData" class="col-sm-12" type="text-editor" v-model="body.text4" :placeholder="$t('text_type_input')" />

                            <div v-if="this.ableToEdit" class="col-sm-12 col-md-12">
                                <div v-for="image in this.inputs.images.body4" class="col-sm-12">
                                    <button type="submit" class="btn btn-secondary btn-sm btn-circle btn-top-right" @click.prevent="removeImageFromChosenPlace(image, 'body4')">
                                        <app-icon :name="'trash'" width="25" height="25" />
                                    </button>

                                    <img :src="image" />
                                </div>
                            </div>
                            <div v-else class="col-sm-12 col-md-12">
                                <div v-for="image in this.inputs.images.body4" class="col-sm-12">
                                    <img :src="image" />
                                </div>
                            </div>
                            <div v-if="this.ableToEdit" class="col-sm-12 text-center">
                                <button type="submit" class="btn btn-primary btn-sm" @click.prevent="addImageTo('body4')"><app-icon :name="'plus'" width="25" height="25" /> {{ $t("add_image") }}</button>
                            </div>

                            <div v-if="!this.ableToEdit" v-html="this.body.text5"></div>
                            <app-input v-else-if="finishedGetData" class="col-sm-12" type="text-editor" v-model="body.text5" :placeholder="$t('text_type_input')" />
                        </div>
                    </section>

                    <!-- Start of fullsize container -->
                    <section class="fullsize-container flex-container" style="display: none !important;">
                        <article class="container-lg row">
                            <div v-if="this.ableToEdit" class="col-sm-12 col-md-6 images">
                                <div v-for="image in this.inputs.images.fullsize">
                                    <button type="submit" class="btn btn-secondary btn-sm btn-circle btn-top-right" @click.prevent="removeImageFromChosenPlace(image, 'fullsize')">
                                        <app-icon :name="'trash'" width="25" height="25" />
                                    </button>

                                    <img :src="image" />
                                </div>
                                <button type="submit" class="btn btn-primary btn-sm" @click.prevent="addImageTo('fullsize')"><app-icon :name="'plus'" width="25" height="25" /> {{ $t("add_image") }}</button>
                            </div>
                            <div v-else class="col-sm-12 col-md-6 images">
                                <div v-for="image in this.inputs.images.fullsize">
                                    <img :src="image" />
                                </div>
                            </div>
                            <div class="col-sm-12 col-md-6">
                                <div v-if="!this.ableToEdit" v-html="this.fullsize.text1"></div>
                                <app-input v-else-if="finishedGetData" type="text-editor" v-model="fullsize.text1" :placeholder="$t('text_type_input')" />
                            </div>
                        </article>
                    </section>

                    <!-- Start of prefooter container -->
                    <section class="body-container container-md row" style="display: none !important;">
                        <div class="col-sm-12 col-md-12">
                            <div v-if="!this.ableToEdit" v-html="this.prefooter.text1"></div>
                            <app-input v-else-if="finishedGetData" class="col-sm-12" type="text-editor" v-model="prefooter.text1" :placeholder="$t('text_type_input')" />
                        </div>
                        <div class="col-sm-12 col-md-12">
                            <div v-if="!this.ableToEdit" v-html="this.prefooter.text2"></div>
                            <app-input v-else-if="finishedGetData" class="col-sm-12" type="text-editor" v-model="prefooter.text2" :placeholder="$t('text_type_input')" />
                        </div>
                    </section>

                    <!-- Start of footer container -->
                    <section class="footer-container container-md row" style="display: none !important;">
                        <div class="col-sm-12">
                            <div v-if="!this.ableToEdit" v-html="this.footer.text1"></div>
                            <app-input v-else-if="finishedGetData" class="col-sm-12" type="text-editor" v-model="footer.text1" :placeholder="$t('text_type_input')" />
                        </div>
                        <div class="col-sm-12 col-md-12">
                            <div v-if="!this.ableToEdit" v-html="this.footer.text2"></div>
                            <app-input v-else-if="finishedGetData" class="col-sm-12" type="text-editor" v-model="footer.text2" :placeholder="$t('text_type_input')" />
                        </div>
                        <div class="col-sm-12 col-md-12">
                            <div v-if="!this.ableToEdit" v-html="this.footer.text3"></div>
                            <app-input v-else-if="finishedGetData" class="col-sm-12" type="text-editor" v-model="footer.text3" :placeholder="$t('text_type_input')" />
                        </div>

                        <div class="col-sm-12 col-md-12">
                            <div v-if="!this.ableToEdit" v-html="this.footer.text4"></div>
                            <app-input v-else-if="finishedGetData" class="col-sm-12" type="text-editor" v-model="footer.text4" :placeholder="$t('text_type_input')" />
                        </div>

                        <div v-if="this.ableToEdit" class="col-sm-12 offset-md-2 col-md-12 text-center">
                            <div v-for="image in this.inputs.images.footer" class="mt-3 mb-3">
                                <button type="submit" class="btn btn-secondary btn-sm btn-circle btn-top-right" @click.prevent="removeImageFromChosenPlace(image, 'footer')">
                                    <app-icon :name="'trash'" width="25" height="25" />
                                </button>

                                <img :src="image" width="100%" />
                            </div>
                            <button type="submit" class="btn btn-primary btn-sm" @click.prevent="addImageTo('footer')"><app-icon :name="'plus'" width="25" height="25" /> {{ $t("add_image") }}</button>
                        </div>
                        <div v-else class="col-sm-12 offset-md-2 col-md-12 text-center">
                            <div v-for="image in this.inputs.images.footer" class="mt-3 mb-3">
                                <img :src="image" width="100%" />
                            </div>
                        </div>
                    </section>

                    <!-- Start of fullsize container -->
                    <section class="fullsize-container footer" style="display: none !important;">
                        <article class="container-lg col-sm-12">
                            <strong>Příležitosti v Název společnosti</strong>
                            <div class="badge-circle">
                                {{ this.advertsCount }}
                            </div>

                            <div class="mt-5 mb-5 text-center">
                                <div class="row career-list">
                                    <div v-for="advert in this.adverts" class="col-sm-12 col-md-6 col-lg-4 panel">
                                        <a :href="advert.url" target="_blank">
                                            <div>
                                                <h2>{{ advert.job }}</h2>
                                                <div class="location">{{ advert.location }}</div>
                                            </div>
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </article>
                    </section>

                    <!-- v-if="this.impersonateAs == 0" -->
                    <div v-if="ableToEdit" class="footer-bottom-fixed">
                        <!-- @todo: doresit ukladani pro vice pozic -->
                        <!--
                        <button type="submit" class="btn btn-light mr-2" @click.prevent="submit" disabled>
                            {{ $t('save_for_all_positions') }}
                        </button>
                        -->
                        <a href="/app-setting" class="btn btn-light btn-with-icon" target="_blank">
                            <i class="custom-icon custom-icon-setting"></i>
                            {{ $t("app_settings") }}
                        </a>
                        <button type="submit" class="btn btn-primary btn-with-icon" @click.prevent="submit">
                            <i class="custom-icon-set custom-icon-set-check"></i>
                            {{ $t("save") }}
                        </button>
                    </div>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
import { FormMixin } from "../../../../../../../core/mixins/form/FormMixin.js";
import GlobalHelperMixin from "../../../../../../Mixins/global/GlobalHelperMixin";

export default {
    name: "SiteEditor",
    mixins: [FormMixin, GlobalHelperMixin],
    props: {
        uploadedImage: {
            required: false,
            type: Object,
        },
        selectedId: {
            type: Number,
        },
        user: {
            type: Object,
        },
    },
    watch: {
        uploadedImage: {
            immediate: true,
            handler(val, oldVal) {
                // If new file has been uploaded
                if (oldVal) {
                    this.insertImageToChosenPlace(val.input.default_file);
                }
            },
        },
        user: {
            immediate: true,
            handler (val, oldVal) {
                if(oldVal){
                    if (location.href.indexOf("impersonate=") != -1){
                        // Admin impersonating as an employeee
                        this.ableToEdit = false;
                    } else if (val.roles[0].id == 5) {
                        // Employee
                        this.ableToEdit = false;
                        this.impersonateUser(val.candidate_id);
                        $('.sidebar').hide();
                    } else {
                        this.ableToEdit = true;

                        if(val.candidate_id){
                            // Admin with an employee account
                            this.impersonateUser(val.candidate_id);
                        } else {
                            // Admin not impersonating, get last added candidate with status 3
                            this.getCandidateAndImpersonateUser();
                        }
                    }
                }

            },
        }
    },
    data() {
        return {
            preloader: false,
            formsPreloader: false,
            tableCommentId: "comments-table",
            finishedGetData: false,
            ableToEdit: false,
            chosenPlace: "",
            newOnboardio: false,
            settings: {},
            inputs: {
                header: "",
                body: "",
                fullsize: "",
                prefooter: "",
                footer: "",
                images: "",
                currentAnswer: [{ id: "" }],
                form: [],
            },
            header: {
                color: "",
                nav: "",
                button: "",
                text: "",
            },
            body: {
                text1: "",
                text2: "",
                text3: "",
                text4: "",
                text5: "",
            },
            fullsize: {
                text1: "",
            },
            prefooter: {
                text1: "",
                text2: "",
            },
            footer: {
                text1: "",
                text2: "",
                text3: "",
                text4: "",
            },
            adverts: {},
            advertsCount: "",
            impersonateAs: 43,
            impersonated: {},
            impersonatedUrl: "",
            courses: [],
            oldCourses: [],
            candidateOptions: [],
            deadline: "",
            deadlineTo: "",
            deadlineFrom: "",
            checklistsLoaded: false,
            checklistsEmployee: [],
            formsLoaded: false,
            forms: [],

            answerLists: [
                { id: "0", value: "Ano" },
                { id: "1", value: "Ne" },
            ],
            testLists: [{ id: "test", value: "" }],
            testField: [
                { id: "1", value: "" },
                { id: "2", value: "" },
                { id: "3", value: "" },
                { id: "4", value: "" },
                { id: "5", value: "" },
                { id: "6", value: "" },
                { id: "7", value: "" },
                { id: "8", value: "" },
                { id: "9", value: "" },
            ],
        };
    },
    created() {
        if (this.selectedUrl) {
            this.modalTitle = this.$t("edit");
            this.preloader = true;
            this.formsPreloader = true;
        } else {
            this.finishedGetData = true;
        }

        // Check if admin and impersonate set and pass id
        if (location.href.indexOf("impersonate=") != -1) {
            let candidateId = parseInt(this.getUrlParameter("impersonate", location.href));
            this.impersonatedUrl = "?impersonate=" + candidateId;
            this.impersonateUser(candidateId);
            this.ableToEdit = false;
        }

        this.getSettings();

        window.onscroll = function() {
            var pageHeight = document.documentElement.offsetHeight,
                windowHeight = window.innerHeight,
                scrollPosition = window.scrollY || window.pageYOffset || document.body.scrollTop + ((document.documentElement && document.documentElement.scrollTop) || 0);

            if (scrollPosition > 253 && window.innerWidth > 991) {
                $(".right-indent").addClass("fixed");
            } else {
                $(".right-indent").removeClass("fixed");
            }
        };
    },
    mounted() {
        if ($(".site-container").length > 0) {
            $("body").addClass("site-editor");
        }

        $("#sidebar").mouseenter(function() {
            $(".card-header").removeClass("active");
            $("#sidebar").focus();
        });

        // Prevent leaving without saving changes
        let warn = false;
        window.addEventListener("beforeunload", (e) => {
            if (!warn) return;
            e.preventDefault();
            // Chrome requires returnValue to be set
            e.returnValue = "";
            this.preloader = false;
        });

        $("body").on("click", ".editor, .btn-top-right", function() {
            $(".floating-bar-fixed-bottom").hide();
            if (window.location.href.indexOf("?id") != -1) {
                warn = true;
            }
        });

        $("body").on("click", ".images .btn", function() {
            $(".floating-bar-fixed-bottom").show();
            if (window.location.href.indexOf("?id") != -1) {
                warn = true;
            }
        });
    },
    methods: {
        /**
         * Actions
         * */

        getUrlParameter(name, url) {
            if (!url) url = location.href;
            name = name.replace(/[\[]/, "\\\[").replace(/[\]]/, "\\\]");
            var regexS = "[\\?&]" + name + "=([^&#]*)";
            var regex = new RegExp(regexS);
            var results = regex.exec(url);
            return results == null ? null : results[1];
        },

        /**
         * Get Additional Data
         * */

        getSettings() {
            // Display available jobs and their onboarding sites
            this.axiosGet("get-basic-setting-data")
                .then((response) => {
                    this.settings = response.data;
                })
                .catch(({ response }) => {})
                .finally(() => {
                    let root = document.documentElement;
                    let fontColor = this.settings.font_color ? this.settings.font_color : "#a33001";
                    let backgroundColor = this.settings.background_color ? this.settings.background_color : "#fdf1ed";
                    root.style.setProperty('--site-font-color', fontColor);
                    root.style.setProperty('--site-background-color', backgroundColor);
                    this.settings.company_banner = this.settings.company_banner ? this.settings.company_banner : "/images/default-bg-image.png";
                });
        },
        getCandidateAndImpersonateUser() {
            let candidateId = 0;
            this.axiosGet('admin/app/last-candidate?status=3').then(response => {
                    candidateId = response.data.id;
                }).catch(({response}) => {
                }).finally(() => {
                    this.impersonateUser(candidateId);
                });
            return candidateId;
        },
        impersonateUser(candidateId) {
                if(candidateId){
                    this.impersonateAs = candidateId;
                }

                // Get impersonated details
                this.axiosGet('admin/app/candidates/'+candidateId).then(response => {

                    this.impersonated = response.data;
                    if(location.href.indexOf("impersonate=") != -1){
                        this.impersonatedUrl = '?impersonate='+candidateId;
                        document.title = this.$t('this_is_how_onboarding_looks_like_for')+' '+this.impersonated.name;
                    }
                    this.getDeadline();
                   
                }).catch(({response}) => {
                }).finally(() => {
                    if(this.impersonated){
                        this.getForms();
                    }
                });
            },
        formatDate(date) {
            let addDate = new Date(date);
            let todaysDate = new Date();
            if (addDate.setHours(0, 0, 0, 0) == todaysDate.setHours(0, 0, 0, 0)) {
                return this.$t("today");
            } else {
                let formattedDate = moment(date).format("DD. MM.");
                return formattedDate;
            }
        },
        formatTime(date) {
            let addDate = new Date(date);
            let todaysDate = new Date();
            let formattedDate = moment(date).format("HH:mm");
            return formattedDate;
        },
        beforeSubmit() {
            this.preloader = true;
        },
        submit() {
            // Fill form inputs with content from multiple fields
            this.inputs.header = '{"color":' + JSON.stringify(this.header.color) + ', "nav":' + JSON.stringify(this.header.nav) + ', "text":' + JSON.stringify(this.header.text) + ', "button":' + JSON.stringify(this.header.button) + "}";
            this.inputs.body = '{"text1":' + JSON.stringify(this.body.text1) + ', "text2":' + JSON.stringify(this.body.text2) + ', "text3":' + JSON.stringify(this.body.text3) + ', "text4":' + JSON.stringify(this.body.text4) + ', "text5":' + JSON.stringify(this.body.text5) + "}";
            this.inputs.fullsize = '{"text1":' + JSON.stringify(this.fullsize.text1) + "}";
            this.inputs.prefooter = '{"text1":' + JSON.stringify(this.prefooter.text1) + ', "text2":' + JSON.stringify(this.prefooter.text2) + "}";
            this.inputs.footer = '{"text1":' + JSON.stringify(this.footer.text1) + ',"text2":' + JSON.stringify(this.footer.text2) + ',"text3":' + JSON.stringify(this.footer.text3) + ',"text4":' + JSON.stringify(this.footer.text4) + "}";

            // console.log(this.inputs.header);
            this.save(this.inputs);
        },
        afterFinalResponse() {
            // console.log('afterFinalResponse');
            this.preloader = false;
            $("#profileDropdown").focus();
            this.$hub.$emit("reload-" + this.tableCommentId);
        },
        afterSuccessFromGetEditData(response) {
            // Fill job filter
            this.filterJobs = response.data.job;

            // Fill every input
            if (response.data.header && response.data.updated_at != "2022-01-01T00:01:00.000000Z") {
                this.header = JSON.parse(response.data.header);
            } else {
                if (this.selectedId == 1) {
                    this.header = { color: "#3082cd", nav: "", text: "<h2></h2><h1><font><b>Ahoj, vítej v {název firmy}!</b></font></h1>", button: "" };
                } else if (this.selectedId == 2) {
                    this.header = { color: "#3082cd", nav: "", text: "<h2></h2><h1><font><b>Tohle je tvůj první den! 🔥</b></font></h1>", button: "" };
                } else if (this.selectedId == 3) {
                    this.header = { color: "#3082cd", nav: "", text: "<h2></h2><h1><font><b>První týden v {název firmy}</b></font></h1>", button: "" };
                } else if (this.selectedId == 4) {
                    this.header = { color: "#3082cd", nav: "", text: "<h2></h2><h1><font><b>Co nás pohání? 🔥</b></font></h1>", button: "" };
                } else if (this.selectedId == 5) {
                    this.header = { color: "#3082cd", nav: "", text: "<h2></h2><h1><font><b>Vítám tě v Crosscafe týmu!</b></font></h1>", button: "" };
                } else if (this.selectedId == 6) {
                    this.header = { color: "#3082cd", nav: "", text: "<h2></h2><h1><font><b>Pravidla</b></font></h1>", button: "" };
                } else if (this.selectedId == 7) {
                    this.header = { color: "#3082cd", nav: "", text: "<h2></h2><h1><font><b>Naše mise a vize 💥</b></font></h1>", button: "" };
                }
            }
            if (response.data.updated_at != "2022-01-01T00:01:00.000000Z") {
                this.body = JSON.parse(response.data.body);
            } else {
                if (this.selectedId == 1) {
                    this.body = {
                        text1: '<font color="#000000" style="background-color: rgb(255, 231, 156);"><i style="">Namísto výchozí fotografie doporučujeme doplnit týmovou fotografii</i><br></font><br><br><h2><b>Jsme rádi, že tě máme!</b></h2><p><br></p><h5><b>Onboarding, který jsme pro tebe vytvořili s tvým \nbudoucím nadřízeným tě trochu seznámí se základními informacemi o společnosti</b>.</h5><p></p><p>Bude také tvým průvodcem celým nástupním procesem, tak aby ses jako každý náš zaměstnanec u nás cítil jako doma. Pokud budeš mít jakékoli dotazy, neváhej mě prosím kdykoli \nkontaktovat.👌🏼</p>',
                        text2: '<p><b>Erika Brožová, <br></b>HR manažer<br><span style="background-color: transparent; color: var(--default-font-color) ;"><br>+420 888 481 546<br></span><span style="background-color: transparent; color: var(--default-font-color) ;">erika@nazevfirmy.cz</span></p><p><span style="background-color: transparent; color: var(--default-font-color) ;"><br></span></p>',
                        text3:
                            '<h2><b>Dáváme riziku hranice.</b><b style="font-size: 2rem; background-color: initial; color: var(--default-font-color);">&nbsp;🙌</b></h2><div><div><br></div><div><h5><b>Požární a výbuchové ochraně se věnujeme od roku 1992 a rozsahem i kvalitou nabídky patříme mezi mezinárodní špičky, v Čechách, na Slovensku a v Polsku pak k prokazatelným jedničkám. </b></h5><b><br>Těžíme ze strategické polohy blízko dvou hranic, špičkových odborníků a i z faktu, že máme pod jednou střechou vše, od vývoje, produkce, servisu až po odborná školení. </b>Právě proto jsme schopni dostát vysokým nárokům na kvalitu i rychlost a spoluurčovat celosvětové trendy.<br><br><b><br></b></div><h4><b style="font-size: 2rem; background-color: initial; color: var(--default-font-color);">🧭&nbsp; Naše mise</b></h4><div><div><b><br></b><h5><b>Dáváme riziku hranice. Naším primárním cílem je, aby naši klienti měli vždy k dispozici sofistikované řešení pro ochranu jejich typu průmyslu.</b></h5></div><div><br></div><div><br></div><div><h2><b>&nbsp;🔭&nbsp; Vize</b></h2><b><br></b><h5><b>Věříme, že to, co my považujeme za běžné požadavky pro bezpečnost provozů se brzy stane plošně používaným standardem aplikovaným po celém světě.</b></h5></div></div></div>',
                        text4:
                            '<div><br><h2><b>👀 Jak to u nás vypadá?</b></h2></div><div><br><iframe frameborder="0" src="//www.youtube.com/embed/ykG-ijOtrAE" width="640" height="360" class="note-video-clip"></iframe><br></div><div><span style="background-color: rgb(255, 231, 156);"><i>Video procházku po firmě pro Vás rádi připravíme ve spolupráci se spřátelenou agenturou. Případně je možné doplnit fotku firemních prostor.</i><br></span><br></div><div><br></div><h2 style="text-align: left;"><b>&nbsp;🏋🏻 Poznej náš tým</b></h2><div style="text-align: center;"><div style="text-align: left;"><br></div></div><p> <iframe width="560" height="315" src="https://www.youtube.com/embed/RLDzdILhjIQ?controls=0" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen=""></iframe><br><font color="#000000" style="background-color: rgb(255, 231, 156);"><i>Video seznámení s Vaším CEO pro Vás rádi připravíme ve spolupráci se spřátelenou agenturou. Případně je možné doplnit týmovou fotku.</i><br></font><br></p><h4><b>Lidé v {název firmy}</b></h4><p></p><p></p><div style="text-align: left;"><span style="background-color: initial; color: var(--default-font-color); font-size: 18px;">"Mám ráda práci v {název-firmy}, protože je to zdravé prostředí, kde jsou lidé moji přátelé, a je bezpečné být kreativní. V {název-firmy} je také plno příležitostí k růstu a učení."</span></div><b style="background-color: transparent; color: var(--default-font-color) ;"><div style="text-align: left;"><b style="background-color: transparent; color: var(--default-font-color) ;">– Lucie,</b><span style="background-color: transparent; color: var(--default-font-color) ; font-size: 18px; font-weight: 400;"> <b>Senior developer</b></span></div></b><p></p><p></p><div style="text-align: left;"><span style="background-color: initial; color: var(--default-font-color); font-size: 18px;">"Nejsme na trhu 20 let, nemáme stovkový stravenky a letní sídlo na horách. Ale to, co je pro mě obrovským benefitem, je flexibilita. Můžu tady pracovat, jak já potřebuju, a je na mně, jestli půjdu na pláž na lehátko, do kavárny a nebo budu v kanceláři."</span></div><span style="background-color: transparent; color: var(--default-font-color) ;"><div style="text-align: left;"><span style="background-color: transparent; color: var(--default-font-color) ; font-size: 18px;">– <b>Z</b></span><b style="background-color: transparent; color: var(--default-font-color) ;">deněk, </b><span style="background-color: transparent; color: var(--default-font-color) ; font-size: 18px;"><b>Marketing Specialist</b></span></div></span><p></p>',
                        text5:
                            '<h2><b>Co s sebou na první den? ✍️</b></h2><div><div><br></div><ul><li>Potvrzení o lékařské prohlídce 🏥</li><li>Občanský průkaz / řidičský průkaz&nbsp;</li><li>Výpis z rejstříku trestu</li><li>Vyplněný dotazník (ke stažení zde)</li><li>Zápočtový list</li><li>Číslo bankovního účtu 🏦</li><li>Kartička zdravotní pojištovny</li><li>Potvrzení o vyřazení z evidence uchazečů o zaměstnání na Úřadu práce (pokud jste byl/a před nástupem do zaměstnání veden na ÚP)</li><li>Pokud ukončení evidence na ÚP bezprostředně navazuje na pracovní poměr potvrzení doložíte později, jakmile Vám ho ÚP vydá.</li><li>Doklad o nejvyšším dosaženém vzdělání + další odborná školení (např. řidič VZV, elektro § 50, atd.)</li><li>Pokud máte děti a chcete uplatňovat daňový bonus, tak jejich rodné listy</li><li>Pokud chcete uplatňovat odpočet na manželku, tak oddací list</li><li>Student – potvrzení o studiu</li><li>ZPS nebo důchodce (starobní, invalidní) – rozhodnutí o přiznání ZPS, důchodu<br><br><br></li></ul></div><div><h2><b>A co tě čeká následující dny? 💥</b></h2><p><b style="background-color: initial; color: var(--default-font-color);"><br></b></p><h5><b style="background-color: initial; color: var(--default-font-color);">Na této stránce najdeš v následujících dnech a každý měsíc něco nového.&nbsp;</b></h5><p></p><p>Najdeš tu důležité informace o firmě, firemní příručku a úkoly, které je potřeba v jednotlivých fázích zkušební doby splnit 😇<br><br></p></div>',
                    };
                } else if (this.selectedId == 2) {
                    this.body = {
                        text1:
                            '<h5><b>Máme pro tebe připravený volnější program, dopoledne se seznámíš s naším týmem a odpoledne spolu zajdeme na oběd. </b></h5><br><h2><b>Co s sebou na první den? ✍️</b></h2><div><div><br></div><ul><li>Potvrzení o lékařské prohlídce 🏥</li><li>Občanský průkaz / řidičský průkaz&nbsp;</li><li>Výpis z rejstříku trestu</li><li>Vyplněný dotazník (ke stažení zde)</li><li>Zápočtový list</li><li>Číslo bankovního účtu 🏦</li><li>Kartička zdravotní pojištovny</li><li>Potvrzení o vyřazení z evidence uchazečů o zaměstnání na Úřadu práce (pokud jste byl/a před nástupem do zaměstnání veden na ÚP)</li><li>Pokud ukončení evidence na ÚP bezprostředně navazuje na pracovní poměr potvrzení doložíte později, jakmile Vám ho ÚP vydá.</li><li>Doklad o nejvyšším dosaženém vzdělání + další odborná školení (např. řidič VZV, elektro § 50, atd.)</li><li>Pokud máte děti a chcete uplatňovat daňový bonus, tak jejich rodné listy</li><li>Pokud chcete uplatňovat odpočet na manželku, tak oddací list</li><li>Student – potvrzení o studiu</li><li>ZPS nebo důchodce (starobní, invalidní) – rozhodnutí o přiznání ZPS, důchodu<br><br></li></ul><div><b style="font-size: 2rem; background-color: initial; color: var(--default-font-color);">Těšíme se na tebe! 👋</b><br></div></div><p><br></p><br><i>Zde uvést ve stručnosti jak bude probíhat první den (pomůže odbourat strach před nástupem). </i>V okolí Karlínského náměstí je plno super restaurací (mexická, vietnamská a francouzská). Výběr je jenom na tobě! Po obě spolu projdeme několik praktických věcí a formalit. A pokud zbyde čas, můžeš prozkoumat náš kampus. Uvidíš, že se ti u nás bude líbit. ;)<p></p>',
                        text2: " ",
                        text3: '<div><b><br></b></div><div><b><br></b></div><h2><b>Kde nás najdete?</b></h2><div><b><br>Pikartská 7, 716 00 Ostrava-Radvanice a Bartovice<br><br></b></div><table class="table table-bordered"><tbody><tr><td>Budova</td><td>Zázemí</td></tr><tr><td>1A</td><td>Caffeterie (po vstupu po pravé straně)</td></tr><tr><td>1B</td><td>Sklady a technické zázemí (po vstupu po levé straně)</td></tr><tr><td>2A</td><td><p>Hlavní hala<br></p></td></tr></tbody></table><div><br></div><iframe style="border:none" src="https://frame.mapy.cz/s/fuhalufero" width="500" height="333" frameborder="0"></iframe>',
                        text4: "&nbsp;",
                        text5: '<h2><b>A co tě čeká následující dny? 💥</b></h2><p><b style="background-color: initial; color: var(--default-font-color);"><br></b></p><h5><b style="background-color: initial; color: var(--default-font-color);">Na této stránce najdeš v následujících dnech a každý měsíc něco nového.&nbsp;</b></h5><p></p><p>Najdeš tu důležité informace o firmě, firemní příručku a úkoly, které je potřeba v jednotlivých fázích zkušební doby splnit 😇<br><br><br><br></p><h5><b>Kontakt na HR oddělení 🧑</b></h5><b><br>Erika Brožová,</b><br><span style="background-color: initial; color: var(--default-font-color); font-size: 16px;">HR manažer</span><p></p><p>+420 888 481 546<br><span style="background-color: initial; color: var(--default-font-color); font-size: 16px;">erika@nazevfirmy.cz</span></p>',
                    };
                } else if (this.selectedId == 3) {
                    this.body = {
                        text1:
                            '<h2><b>💡 Co tě čeká (a nemine)?</b></h2><p><br></p><h5><b>Druhý den po nástupu se spolu podíváme, co aktuálně tvůj tým řeší, seznámíš se s nástroji, které používáme a pomalu se zapojíš do práce.&nbsp;</b></h5><p></p><p>Někteří z nás pracují na homeoffice, ale většinu času trávíme v terénu.<br>Pokud budeš mít jakékoli dotazy, neváhej mě prosím kdykoli \nkontaktovat na HR oddělení. O pár řádků níže najdeš kontakt. 🌱<br><br><br></p><h5><b>V průběhu prvního týdne tě seznámíme s mentorem 🧑‍🏫</b></h5>Mentor ti pomůže získat sebevědomí v novém prostředí a předá ti všechny potřebné zkušenosti ohledně pracovních postupů a bezpečnosti. Seznámí tě s chodem společnosti, procesy a nástroji, ale provede tě také kulturním životem ve firmě. <br><i><br><span style="background-color: rgb(255, 231, 156);">Doporučení: Pro roli mentora/buddyho vyberte osobu, která zná společnost velmi dobře a vykonává stejnou profesi. Nemělo by jít o nikoho z vedení, aby nedocházelo k napjatým situacím a atmosféra se nesla na uvolněné vlně. Mentor měl umět aktivně naslouchat, navazovat kontakt a být přátelský.</span></i><br><br><p></p><p><b>Níže si přečti vše, co potřebuješ vědět o tom, jak pracujeme 🧯</b></p>',
                        text2: " ",
                        text3:
                            '<h4><b style="font-size: 2rem; background-color: initial; color: var(--default-font-color);">🧭&nbsp; Naše mise</b></h4><div><div><b><br></b><h5><b>Dáváme riziku hranice. Naším primárním cílem je, aby naši klienti měli vždy k dispozici sofistikované řešení pro ochranu jejich typu průmyslu.</b></h5></div><div><br></div><div><br></div><div><h2><b>&nbsp;🔭&nbsp; Vize</b></h2><b><br></b><h5><b>Věříme, že to, co my považujeme za běžné požadavky pro bezpečnost provozů se brzy stane plošně používaným standardem aplikovaným po celém světě.</b></h5></div><div><b><br></b></div><div><b><br></b></div><h2><b>&nbsp;⚖️&nbsp; Hodnoty<br></b></h2></div><br><table class="table table-bordered"><tbody><tr><td><h5 style="text-align: center; "><b>Odpovědnost 👮&nbsp;&nbsp;</b></h5></td></tr></tbody></table><div><div><b>Podniky po celém světě nám důvěřují s klíčovými technologiemi, které jsou zásadní pro jejich podnikání. </b>Musíme zajistit aby nedošlo k nezvratným škodám na majetku. Když něco pokazíme, zmeškáme termín nebo zpomalíme, <b>záleží na tom. </b>Zodpovědnost bereme vážně.</div><div><br></div><div><br></div></div><table class="table table-bordered" style="text-align: center;"><tbody><tr><td><h5><b>Bezpečnost na prvním místě 🔥&nbsp;&nbsp;</b></h5></td></tr></tbody></table><div><div>Své zaměstnance chráníme a vytváříme pro ně takové bezpečnostní podmínky, aby svou práci mohli odvádět <b>plnohodnotně a bez obav</b>.&nbsp;</div><div><br></div><div><br></div></div><table class="table table-bordered"><tbody><tr><td><h5 style="text-align: center; "><b>Láska k technologiím a práci v terénu 🤖&nbsp;&nbsp;</b></h5></td></tr></tbody></table><div><div>Kancelářská práce není úplně pro vás a <b>lákají vás technologie?</b> Budeme společně pomáhat se zabezpečením průmyslu! Ostatní činnosti, které budete při práci vykonávat, Vás naučíme.</div><div><br></div><div><br></div></div><table class="table table-bordered"><tbody><tr><td><h5 style="text-align: center; "><b>Organizace a pořádek dělá přátele 🏷️&nbsp; &nbsp;</b></h5></td></tr></tbody></table><div><div>Máte rádi organizaci, pořádek ve věcech, číslech a tabulkách? My také!<br></div><div><br></div><div><br></div></div>',
                        text4: "&nbsp;",
                        text5: '<div><h2><b>A co tě čeká následující dny? 💥</b></h2><p><b style="background-color: initial; color: var(--default-font-color);"><br></b></p><h5><b style="background-color: initial; color: var(--default-font-color);">Na této stránce najdeš v následujících dnech a každý měsíc něco nového.&nbsp;</b></h5><p></p><p>Najdeš tu důležité informace o firmě, firemní příručku a úkoly, které je potřeba v jednotlivých fázích zkušební doby splnit 😇<br></p></div><h5><b><br>Kontakt na HR oddělení 🧑</b></h5><b><br>Erika Brožová,</b><br><span style="background-color: initial; color: var(--default-font-color); font-size: 16px;">HR manažer</span><p></p><p>+420 888 481 546<br><span style="background-color: initial; color: var(--default-font-color); font-size: 16px;">erika@nazevfirmy.cz</span></p>',
                    };
                } else if (this.selectedId == 4) {
                    this.body = {
                        text1:
                            "<p></p><div><br><h3><b><br>Jsme otevření 😇</b></h3></div><div><b>Pro lepší představu, co pro nás znamená otevřenost, se společně mrkneme na konkrétní příklad z praxe.&nbsp;</b><br><br>{název-firmy} budujeme jako svobodnou firmu, proto nám záleží na otevřenosti a flexibilitě. Např. k firemním číslům, jako třeba počet platících uživatelů nebo jaké jsou náklady firmy, mají tak přístup všichni interní zaměstnanci. Každý z firmy se může na cokoliv zeptat a v naprosté většině případů se mu dostane konkrétní odpovědi.</div><div><br></div><h3><b>Feedback = základ zdravých vztahů v práci 👐</b></h3><div><b>Feedback vnímáme jakou klíčový nástroj pro dobré mezilidské pracovní i nepracovní vztahy. <br></b><br>Každý měsíc máme 1-to-1 schůzku, kde navzájem námořník se svým kapitánem zhodnotí minulý měsíc.</div><div><br></div><div>Bavíme se o práci, fungování týmu nebo o čemkoliv, co nefunguje optimálně a dává smysl vylepšit či změnit. Je to bezpečné místo, kde je možné říct cokoliv.&nbsp;</div><div><br></div><h3><b>Víc hlav víc ví 🚀</b></h3><div><b>Jednou za několik měsíců si vedoucí týmů v naší firmě dělají schůzku s celým týmem, kde se otevřeně pobavíme o všem, co se týmu týká. K tomu používáme lepící papírky. Každý napíše na papírek, s čím je (zelený) či není (červený) spokojený.</b></div><div><br></div><div>Negativní body potom společně diskutujeme a co dává smysl změnit či řešit, tomu dáme konkrétního řešitele příp. termín.</div><div><br></div><div>Je to týmové řešení problémů, na kterých se shodneme, že nás trápí. Pokud bychom s vybranými úkoly do příští týmové schůzky nepohli, zapracujeme na tom příště.</div>",
                        text2: " ",
                        text3: " ",
                        text4: " ",
                        text5: " ",
                    };
                } else if (this.selectedId == 5) {
                    this.body = {
                        text1:
                            '<p><b>Vítám tě v týmu!<br><br>Mým cílem je, aby naši klienti měli vždy k dispozici sofistikované řešení pro ochranu jejich typu průmyslu. Podobnou chuť a motivaci vidím i u svých kolegů, touhu se neustále vzdělávat nejen v oblasti výbuchové a požární ochrany ale i v technologických procesech samotných průmyslových provozů, které je nutné zabezpečit. </b>Věřím, že to, co my považujeme za běžné požadavky pro bezpečnost provozů se brzy stane plošně používaným standardem aplikovaným po celém světě. Vyspělý engineering, progresivní tým lidí a široké spektrum high-tech produktů je to, co z {název-firmy} dělá volbu číslo jedna u našich zákazníků.&nbsp;<br><i><br><span style="background-color: rgb(255, 231, 156);">Doporučení: pozdrav a motivační dopis zaměsntanci je vhodné doplnit klíčovými informacemi o tom, co pomáháme budovat.&nbsp;</span></i></p><p><b>My dáváme riziku hranice.</b></p><p><span style="background-color: initial; color: var(--default-font-color); font-size: 16px;">Jan Novák<br></span><span style="background-color: initial; color: var(--default-font-color); font-size: 16px;">Ředitel společnosti</span></p>',
                        text2: " ",
                        text3: "",
                        text4: " ",
                        text5: " ",
                    };
                } else if (this.selectedId == 6) {
                    this.body = {
                        text1:
                            '<h2><b>💯 Pravidla pro čerpání benefitů</b></h2><div><br></div><table class="table table-bordered"><tbody><tr><td><i>Typ</i></td><td><i>Podmínka</i></td><td><i>Poznámka</i></td></tr><tr><td>Služební auto</td><td>1 rok v zaměstnání</td><td>I pro osobní účely</td></tr><tr><td>Příspěvky na důchodové pojištění&nbsp;</td><td>od 1. dne v zaměstnání</td><td>Až do výše XY</td></tr><tr><td>Volný stup do firemní SPA</td><td>od 1. dne v zaměstnání</td><td><br></td></tr></tbody></table><div><ul><li><i style="background-color: rgb(255, 231, 156);">Zde uveďte základní pravidla pro čerpání benefitů ve vaší firmě</i></li><li>Kompletní podmínky pro čerpání benefitů: <a href="http://google.com" target="_blank">odkaz na dokument</a></li></ul><div><br><br></div><h2><b>🌴 Pravidla pro dovolené&nbsp;</b></h2><div><br></div></div><table class="table table-bordered"><tbody><tr><td><i>Typ</i></td><td><i>Počet dní</i></td><td><i>Poznámka</i></td></tr><tr><td>Dovolená</td><td>25</td><td>Plně hrazeno.&nbsp;</td></tr><tr><td>Sick days&nbsp;</td><td>4</td><td>Plně hrazeno. Další dny nehrazeny</td></tr></tbody></table><div><div><b><br>Často kladené otázky 🙋</b></div><ul><li><b>Přenáší se nevyužité dny dovolené do dalšího roku?</b><br><i>Ano, do nového roku můžeme převést až 5 dní.</i></li><li><b>Pokud společnost opustím, dostanu nějaké kompenzace za nevyužité dovolené?</b><br><i>Ano, spolu s poslední výplatou obdržíte na účetním oddělení kompenzace podle počtu dní, které nebyly využity.</i></li></ul></div><br><b><font color="#cec6ce">–––––––––––––––––––––––––––––––––––––––––––––––––––––––––</font></b><br><br><h3><b>Google Formuláře&nbsp;</b></h3><br><i><font color="#000000" style="background-color: rgb(255, 231, 156);">Kamkoli na onboarding stránky můžete vložit interaktivní prvky, jako např. formulář, a to ať už ve firmě používáte Google Forms nebo jinou službu. 👌</font></i><p></p><p><i><br><font color="#000000" style="background-color: rgb(255, 231, 156);">Můžete si tak s Onboardiem zároveň zjednodušit správu i jiných agend mimo onboarding, např. výběr dovolené. 💪</font></i><br><br><iframe src="https://docs.google.com/forms/d/e/1FAIpQLScezkkNZmWzO9j4SgzMHj6vdJRk4NOLXTrGTvFP5146vAfLPg/viewform?embedded=true" width="640" height="738" frameborder="0" marginheight="0" marginwidth="0">Loading…</iframe></p><div><br></div><div><i><font color="#000000" style="background-color: rgb(255, 231, 156);">Lze doplnit i jakýkoli jiný Google formulář nebo odkaz do systému, kde lze vypnit žádost o výběr dovolené.</font></i></div><p></p>',
                        text4: '<h2><iframe src="https://docs.google.com/forms/d/e/1FAIpQLScs4EH2fHD4me64dOFk_8JsotNfxWey-0wt-gHOyeptl-_o4Q/viewform?embedded=true" width="640" height="1790" frameborder="0" marginheight="0" marginwidth="0" style="background-color: initial; color: var(--default-font-color); font-size: 16px;"></iframe><i style="color: var(--default-font-color); font-size: 16px; background-color: rgb(255, 231, 156);">Lze doplnit i jakýkoli jiný Google formulář nebo odkaz do dotazníku, kde sbíráte zpětnou vazbu.</i><br></h2>',
                        text5: '<div><h2><b>A je po zkušební době. 💥</b></h2><p><b style="background-color: initial; color: var(--default-font-color);"><br></b></p><h5><b style="background-color: initial; color: var(--default-font-color);">Doufáme, že se ti u nás líbí.</b></h5><p></p><p>Na tuto stránku se můžeš kdykoli vrátit. Najdeš tu důležité informace o firmě, firemní příručku a úkoly, které je potřeba v období po zkušební době splnit 😇<br><br></p></div><h5><b>Kontakt na HR oddělení 🧑</b></h5><b><br>Erika Brožová,</b><br><span style="background-color: initial; color: var(--default-font-color); font-size: 16px;">HR manažer</span><p></p><p>+420 888 481 546<br><span style="background-color: initial; color: var(--default-font-color); font-size: 16px;">erika@nazevfirmy.cz</span></p>',
                        text2: " ",
                        text3: " ",
                        text4: " ",
                        text5: " ",
                    };
                } else if (this.selectedId == 7) {
                    this.body = {
                        text1: "Abc",
                        text2:
                            '<h4><b style="font-size: 2rem; background-color: initial; color: var(--default-font-color);">🧭&nbsp; Naše mise</b></h4><div><div><b><br></b><h5><b>Dáváme riziku hranice. Naším primárním cílem je, aby naši klienti měli vždy k dispozici sofistikované řešení pro ochranu jejich typu průmyslu.</b></h5></div><div><br></div><div><br></div><div><h2><b>&nbsp;🔭&nbsp; Vize</b></h2><b><br></b><h5><b>Věříme, že to, co my považujeme za běžné požadavky pro bezpečnost provozů se brzy stane plošně používaným standardem aplikovaným po celém světě.</b></h5></div><div><b><br></b></div><div><b><br></b></div><h2><b>&nbsp;⚖️&nbsp; Hodnoty<br></b></h2></div><br><table class="table table-bordered"><tbody><tr><td><h5 style="text-align: center; "><b>Odpovědnost 👮&nbsp;&nbsp;</b></h5></td></tr></tbody></table><div><div><b>Podniky po celém světě nám důvěřují s klíčovými technologiemi, které jsou zásadní pro jejich podnikání. </b>Musíme zajistit aby nedošlo k nezvratným škodám na majetku. Když něco pokazíme, zmeškáme termín nebo zpomalíme, <b>záleží na tom. </b>Zodpovědnost bereme vážně.</div><div><br></div><div><br></div></div><table class="table table-bordered" style="text-align: center;"><tbody><tr><td><h5><b>Bezpečnost na prvním místě 🔥&nbsp;&nbsp;</b></h5></td></tr></tbody></table><div><div>Své zaměstnance chráníme a vytváříme pro ně takové bezpečnostní podmínky, aby svou práci mohli odvádět <b>plnohodnotně a bez obav</b>.&nbsp;</div><div><br></div><div><br></div></div><table class="table table-bordered"><tbody><tr><td><h5 style="text-align: center; "><b>Láska k technologiím a práci v terénu 🤖&nbsp;&nbsp;</b></h5></td></tr></tbody></table><div><div>Kancelářská práce není úplně pro vás a <b>lákají vás technologie?</b> Budeme společně pomáhat se zabezpečením průmyslu! Ostatní činnosti, které budete při práci vykonávat, Vás naučíme.</div><div><br></div><div><br></div></div><table class="table table-bordered"><tbody><tr><td><h5 style="text-align: center; "><b>Organizace a pořádek dělá přátele 🏷️&nbsp; &nbsp;</b></h5></td></tr></tbody></table><div><div>Máte rádi organizaci, pořádek ve věcech, číslech a tabulkách? My také!<br></div><div><br></div><div><br></div></div>',
                        text3: "<p></p><p></p>",
                        text4: " ",
                        text5: " ",
                    };
                }
            }
            if (response.data.fullsize) {
                this.fullsize = JSON.parse(response.data.fullsize);
            }
            if (response.data.prefooter) {
                this.prefooter = JSON.parse(response.data.prefooter);
            }
            if (response.data.footer) {
                this.footer = JSON.parse(response.data.footer);
            }

            // Place images into the right spot
            if (response.data.images && response.data.updated_at != "2022-01-01T00:01:00.000000Z") {
                this.inputs.images = JSON.parse(response.data.images);
            } else {
                if (this.selectedId == 1) {
                    this.inputs.images = { logo: ["/storage/site/60e732d5a185f.png"], header: ["/storage/site/60e80ae86b4b8.jpg"], body1: ["/storage/site/60fd98c2244e6.jpg"], body2: ["/storage/site/60fd60c19dff7.jpg"], body3: [], body4: [], fullsize: ["/storage/site/60e81d3c756dd.jpg"], prefooter: [], footer: ["/storage/site/60e834bd848d4.jpg"] };
                } else if (this.selectedId == 2) {
                    this.inputs.images = { logo: ["/storage/site/60e732d5a185f.png"], header: ["/storage/site/60e80ae86b4b8.jpg"], body1: [], body2: [], body3: [], body4: [], fullsize: ["/storage/site/60e81d3c756dd.jpg"], prefooter: [], footer: ["/storage/site/60e834bd848d4.jpg"] };
                } else if (this.selectedId == 3) {
                    this.inputs.images = { logo: ["/storage/site/60e732d5a185f.png"], header: ["/storage/site/60e80ae86b4b8.jpg"], body1: ["/tenancy/storage/tenantrsbp/app/public//site/61d21f15d5ff8.jpg"], body2: ["/storage/site/60fd60c19dff7.jpg"], body3: [], body4: [], fullsize: ["/storage/site/60e81d3c756dd.jpg"], prefooter: [], footer: ["/storage/site/60e834bd848d4.jpg"] };
                } else if (this.selectedId == 4) {
                    this.inputs.images = { logo: ["/storage/site/60e732d5a185f.png"], header: ["/storage/site/60e80ae86b4b8.jpg"], body1: [], body2: ["/storage/site/60fd60c19dff7.jpg"], body3: [], body4: [], fullsize: ["/storage/site/60e81d3c756dd.jpg"], prefooter: [], footer: ["/storage/site/60e834bd848d4.jpg"] };
                } else if (this.selectedId == 5) {
                    this.inputs.images = { logo: ["/storage/site/60e732d5a185f.png"], header: ["/storage/site/60e80ae86b4b8.jpg"], body1: [], body2: [null], body3: [], body4: [], fullsize: ["/storage/site/60e81d3c756dd.jpg"], prefooter: [], footer: ["/storage/site/60e834bd848d4.jpg"] };
                } else if (this.selectedId == 6) {
                    this.inputs.images = { logo: ["/storage/site/60e732d5a185f.png"], header: ["/storage/site/60e80ae86b4b8.jpg"], body1: [], body2: [null], body3: [], body4: [], fullsize: ["/storage/site/60e81d3c756dd.jpg"], prefooter: [], footer: ["/storage/site/60e834bd848d4.jpg"] };
                } else if (this.selectedId == 7) {
                    this.inputs.images = { logo: ["/storage/site/60e732d5a185f.png"], header: ["/storage/site/60e80ae86b4b8.jpg"], body1: ["/storage/site/60fd98c2244e6.jpg"], body2: [], body3: [], body4: [], fullsize: ["/storage/site/60e81d3c756dd.jpg"], prefooter: [], footer: ["/storage/site/60e834bd848d4.jpg"] };
                }
            }

            // Get active adverts
            this.axiosGet("admin/app/jobs?status=1").then((response) => {
                this.adverts = response.data;
                this.advertsCount = Object.keys(this.adverts).length;
            });

            this.preloader = false;
            this.finishedGetData = true;
        },
        afterSuccess(res) {
            this.$toastr.s(res.data.message);
        },
        afterError(res) {
            this.$toastr.e(res.data.message);
        },
        clear() {
            this.inputs = {};
            this.fieldStatus = {
                isSubmit: false,
            };
        },

        /**
         * Image upload and set to Chosen Place
         */
        addImageTo(place) {
            this.chosenPlace = place;
            this.$emit("getImageAction", place);
        },
        insertImageToChosenPlace(url) {
            if (this.chosenPlace == "logo") {
                this.inputs.images.logo = [];
                this.inputs.images.logo.push(url);
            } else if (this.chosenPlace == "header") {
                this.inputs.images.header = [];
                this.inputs.images.header.push(url);
            } else if (this.chosenPlace == "body1") {
                this.inputs.images.body1.push(url);
            } else if (this.chosenPlace == "body2") {
                this.inputs.images.body2.push(url);
            } else if (this.chosenPlace == "body3") {
                this.inputs.images.body3.push(url);
            } else if (this.chosenPlace == "body4") {
                this.inputs.images.body4.push(url);
            } else if (this.chosenPlace == "fullsize") {
                this.inputs.images.fullsize.push(url);
            } else if (this.chosenPlace == "prefooter") {
                this.inputs.images.prefooter.push(url);
            } else if (this.chosenPlace == "footer") {
                this.inputs.images.footer.push(url);
            }
        },
        removeImageFromChosenPlace(url, place) {
            if (place == "logo") {
                for (var i = 0; i <= this.inputs.images.logo.length - 1; i++) {
                    if (this.inputs.images.logo[i] == url) {
                        this.inputs.images.logo.splice(i--, 1);
                    }
                }
            } else if (place == "header") {
                for (var i = 0; i <= this.inputs.images.header.length - 1; i++) {
                    if (this.inputs.images.header[i] == url) {
                        this.inputs.images.header.splice(i--, 1);
                    }
                }
            } else if (place == "body1") {
                for (var i = 0; i <= this.inputs.images.body1.length - 1; i++) {
                    if (this.inputs.images.body1[i] == url) {
                        this.inputs.images.body1.splice(i--, 1);
                    }
                }
            } else if (place == "body2") {
                for (var i = 0; i <= this.inputs.images.body2.length - 1; i++) {
                    if (this.inputs.images.body2[i] == url) {
                        this.inputs.images.body2.splice(i--, 1);
                    }
                }
            } else if (place == "body3") {
                for (var i = 0; i <= this.inputs.images.body3.length - 1; i++) {
                    if (this.inputs.images.body3[i] == url) {
                        this.inputs.images.body3.splice(i--, 1);
                    }
                }
            } else if (place == "body4") {
                for (var i = 0; i <= this.inputs.images.body4.length - 1; i++) {
                    if (this.inputs.images.body4[i] == url) {
                        this.inputs.images.body4.splice(i--, 1);
                    }
                }
            } else if (place == "fullsize") {
                for (var i = 0; i <= this.inputs.images.fullsize.length - 1; i++) {
                    if (this.inputs.images.fullsize[i] == url) {
                        this.inputs.images.fullsize.splice(i--, 1);
                    }
                }
            } else if (place == "prefooter") {
                for (var i = 0; i <= this.inputs.images.prefooter.length - 1; i++) {
                    if (this.inputs.images.prefooter[i] == url) {
                        this.inputs.images.prefooter.splice(i--, 1);
                    }
                }
            } else if (place == "footer") {
                for (var i = 0; i <= this.inputs.images.footer.length - 1; i++) {
                    if (this.inputs.images.footer[i] == url) {
                        this.inputs.images.footer.splice(i--, 1);
                    }
                }
            }
        },
        changeImageOrder(arr, from, to) {
            return arr.reduce((prev, current, idx, self) => {
                if (from === to) {
                    prev.push(current);
                }
                if (idx === from) {
                    return prev;
                }
                if (from < to) {
                    prev.push(current);
                }
                if (idx === to) {
                    prev.push(self[from]);
                }
                if (from > to) {
                    prev.push(current);
                }
                return prev;
            }, []);
        },
    },
};
</script>
